module.exports = __webpack_public_path__ + "img/fronx-ta-imperial-gray.06a880fd.png";